import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class UserServiceService {
  readonly baseURL = DDP_ENV.userUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllUsers(page, status, size, regExp) {
      console.log('Inside get users');
      return this._http.get(this.baseURL + '/user?page=' + page + '&size=' + size + '&regexPattern=' + regExp + '&isActive=' + status, this.buildHeaders());
  }

  resetPassword(userName): Observable<any> {
    return this._http.get(this.baseURL + '/user/' + userName + '/reset/password', this.buildHeaders())
      .map((res: Response) => res.json());
  }

  /* Unblock an user */
  unblockUser(user, userId): Observable<any> {
    return this._http.put(this.baseURL + '/user/' + userId + '/unblock', user, this.buildHeaders())
      .map((res: Response) => {
        return res.json();
      });
  }

  /* Unblock an user */
  blockUser(user, userId): Observable<any> {
    return this._http.put(this.baseURL + '/user/' + userId + '/block', user, this.buildHeaders())
      .map((res: Response) => {
        return res.json();
      });
  }

  /* Resend mail */
  resendConfirmationEmail(userName): Observable<any> {
    return this._http.get(this.baseURL + '/user/' + userName + '/resend/confirmation', this.buildHeaders());
      //.map((res: Response) => res.json());
  }

  changePassword(passwordRequest, userId) {
    console.log('Inside change users password');
    return this._http.put(this.baseURL + '/user/' + userId + '/password' , passwordRequest, this.buildHeaders());
  }
    /* Construct a common header */
    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }

  addUser(user) {
      return this._http.post(this.baseURL + '/user/register', user, this.buildHeaders());
  }
}
